import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { ContactUs } from '../models/contact-us';

@Injectable()
export class ContactUsService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) { }

  /*getContactList(id: string):Observable<ContactUs> {
      let data :AngularFireObject<ContactUs> = this.db.object(Constants.EVENT_URL+'/'+id+Constants.CONTACT_US_URL);
      return  data.valueChanges();
  }*/

  getContactList(id: string): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + id + Constants.CONTACT_US_URL);
    }
    return null;
  }

  getSingleContactList(id: string, contactId: string): Observable<ContactUs> {
    if (contactId != null) {
      let data: AngularFireObject<ContactUs> = this.db.object(Constants.EVENT_URL + '/' + id + Constants.CONTACT_US_URL + "/" + contactId);
      return data.valueChanges();
    }
  }

  updateContectPosition(eventID, contactList, contactDeletedIdList) {
    /*if(contactDeletedIdList != null) {
      for(let id of contactDeletedIdList) {
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTACT_US_URL+'/'+id).set(null);
      } for(let item of contactList) {
        console.log(item.$key, item.position);
        let key = item.$key;
        this.db.object(Constants.EVENT_URL+'/'+eventID+Constants.CONTACT_US_URL+"/"+key).update({position:item.position});
     }
    } else {*/
    for (let item of contactList) {
      console.log(item.$key, item.position);
      let key = item.$key;
      this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.CONTACT_US_URL + "/" + key).update({ position: item.position });
    }
    //}
  }

  addContact(eventID: string, contactUs: ContactUs) {
    return this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.CONTACT_US_URL).push(contactUs).key;
  }

  updateContact(eventID: string, contactId: string, contactUs: ContactUs): Promise<any> {
    return this.db.object(Constants.EVENT_URL + '/' + eventID + Constants.CONTACT_US_URL + "/" + contactId).set(contactUs);
  }

  deleteContact(contactId, eventID, contactList): Promise<boolean> {
    if (contactList) {
      this.db.list(Constants.EVENT_URL + '/' + eventID + Constants.CONTACT_US_URL).remove(contactId).then(res => {
        return this.upDateOrder(eventID, contactList);
      });
    } else {
      return this.upDateOrder(eventID, contactList);
    }
  }

  upDateOrder(eventId, contactList): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (contactList) {
        let i = 0;
        for (let item of contactList) {
          console.log(item.$key, item.position);
          let key = item.$key;
          this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CONTACT_US_URL + "/" + key).update({ position: item.position }).catch(e => { resolve(false); });
          if(i == contactList.length-1) {resolve(true);}i++;
        }
      } else {
        resolve(true);
      }
    });

  }


}



// WEBPACK FOOTER //
// /app/src/app/core/services/contact-us.service.ts